/* global twttr, FB */

import {Event} from '../../../lib/constants/Event'

/**
 * Add external scripts for example Twitter and Facebook SDKs
 * @TODO Move this to socialembed plugin!!!
 */
const loadExternalDependencies = function({configurator, api}) {

    const disableExternalSocialEmbeds = configurator.getWriterConfigValue('disableExternalSocialEmbeds', false)
    if (disableExternalSocialEmbeds) {
        return false
    }

    const facebookAppId = configurator.getWriterConfigValue('facebookAppId')

    // Load Facebook
    if (facebookAppId) {
        api.browser.addExternalScript('https://connect.facebook.net/en_US/sdk.js')
            .then(() => {
                window.fbAsyncInit = () => {
                    setTimeout(() => {
                        FB.init({
                            appId: facebookAppId,
                            version: 'v2.10',
                            xfbml: true
                        })
                        api.events.trigger('__internal', Event.FACEBOOK_READY, {})
                    }, 0)
                }
            })

    } else {
        console.warn('No facebookAppId provided in configuration')
    }

    // Load twitter
    api.browser.addExternalScript('https://platform.twitter.com/widgets.js')
        .then(() => {
            setTimeout(() => {
                twttr.ready(() => {
                    api.events.trigger('__internal', Event.TWITTER_READY, {})
                })

                /**
                 * Listen to an event when the tweet is done loading. Then we can modify the inner style of the tweet
                 * to enable a width of 100%
                 */
                twttr.events.bind('rendered', (event) => {
                    const style = event.target.shadowRoot.querySelector('style')
                    style.innerHTML += ' :host {  max-width: 100%; } .EmbeddedTweet {width:100% !important; max-width:100% !important; border:none !important; } .EmbeddedTweet-tweet { border:none !important; }'
                })
            })
        })

    // Load Instagram?
    //    <script async defer src="//platform.instagram.com/en_US/embeds.js">
}

export {loadExternalDependencies}
